module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$store.state.user.type == 'admin') ? _c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n      Filter By\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.profitLossRecord()
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staff_id"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Income")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Indirect Income : " + _vm._s(_vm.indInc))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_c('tbody', _vm._l((_vm.indirectIncomeRecords), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [(item.br_ledgers) ? _c('div', _vm._l((item.br_ledgers), function(item_ledger) {
      return _c('div', {
        key: item_ledger.id
      }, [(item_ledger.cr_amt || item_ledger.dr_amt) ? _c('table', {
        staticClass: "table"
      }, [_c('thead', [(item_ledger.branch) ? _c('th', {
        staticClass: "text-center",
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("Branch : "), _c('strong', [_vm._v(_vm._s(item_ledger.branch.name))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Opening Balance :"), (item_ledger.fy_opening_balance) ? _c('span', [_vm._v("  " + _vm._s(item_ledger.fy_opening_balance.openingBalance))]) : _c('span', [_vm._v(" 0")])]), _vm._v(" "), _c('td', [_vm._v("Dr :"), (item_ledger.dr_amt) ? _c('span', [_vm._v("  " + _vm._s(item_ledger.dr_amt))]) : _c('span', [_vm._v(" 0")])]), _vm._v(" "), _c('td', [_vm._v("Cr :"), (item_ledger.cr_amt) ? _c('span', [_vm._v("  " + _vm._s(item_ledger.cr_amt))]) : _c('span', [_vm._v(" 0")])])])])]) : _vm._e()])
    }), 0) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Expense")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Indirect Expense : " + _vm._s(_vm.indExp))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_c('tbody', _vm._l((_vm.indirectExpenseRecords), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [(item.br_ledgers) ? _c('div', _vm._l((item.br_ledgers), function(item_ledger) {
      return _c('ul', {
        key: item_ledger.id
      }, [_c('li', [(item_ledger.branch) ? _c('span', [_c('strong', [_vm._v(_vm._s(item_ledger.branch.name))])]) : _vm._e(), _vm._v(" "), (item_ledger.cr_amt) ? _c('span', [_c('br'), _vm._v(" Cr : " + _vm._s(item_ledger.cr_amt))]) : _vm._e(), _vm._v(" "), (item_ledger.dr_amt) ? _c('span', [_c('br'), _vm._v(" Dr : " + _vm._s(item_ledger.dr_amt))]) : _vm._e()])])
    }), 0) : _vm._e()])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title text-warning"
  }, [_vm._v("Profit-Loss")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fadaf412!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/ProfitLoss.vue
// module id = 950
// module chunks = 0